module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Black.3c706f3e686f8c05e4c6ff5395496d18.ttf";